import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

interface IPayload {
  startDate: string | null;
  endDate: string | null;
  fineStatus: string;
  createdBy: string;
  offenceCode: string;
  pageNumber: number;
  perPage: number;
  sortingOn: string;
  isDescending: boolean;
  reportType?: string;
}

export const getReportData = createAsyncThunk(
  "reports/finesReport",
  async (data: IPayload) => {
    const url =
      data.reportType === "Fines Report"
        ? "api/Reports/GetFinesReport"
        : data.reportType === "Collection Report"
        ? "api/Reports/GetCollectionReport"
        : "api/Reports/GetStationPerformanceReport";
    const response: any = await axios.post(url, data);
    return response.data || response?.response?.data;
  }
);

export const reportsSlice = createSlice({
  name: "reports",
  initialState: {
    data: {
      totalRecords: 0,
      totalPages: 0,
      list: [],
    },
    loading: false,
    pageProps: {
      isDescending: false,
      pageNumber: 1,
      perPage: 10,
      searchText: "",
      sortingOn: "",
      startDate: "",
      endDate: "",
      fineStatus: "all",
      createdBy: "all",
      offenceCode: "all",
      reportType: "",
    },
  },
  reducers: {
    onChangeReportsList: (state, action) => {
      state.pageProps = action.payload;
    },
    clearReportsData: (state) => {
      state.data = {
        totalRecords: 0,
        totalPages: 0,
        list: [],
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReportData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getReportData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload?.result ?? {};
      })
      .addCase(getReportData.rejected, (state) => {
        state.loading = false;
      });
  },
});
export const { onChangeReportsList, clearReportsData } = reportsSlice.actions;

export default reportsSlice.reducer;
